import { render } from "./UserLoginModal.vue?vue&type=template&id=79088b64"
import script from "./UserLoginModal.vue?vue&type=script&lang=js"
export * from "./UserLoginModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__